import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import { getCloudOrgStructureElement } from "slices/cloudOrgStructure";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

const registry = createLookupRegistry();

const NiceResourceGroup = (props) => {
  const wantedResource = props.children;
  const isBillingAccount = wantedResource === "billingAccount";

  const resourceGroup = useSelector((state) =>
    state.cloudOrgStructure?.data?.list?.find((org) => org.id === wantedResource)
  );

  useLookupOnce(
    registry,
    wantedResource,
    (id) => getCloudOrgStructureElement({ id }),
    { resolved: !!resourceGroup, skip: isBillingAccount }
  );

  if (isBillingAccount) {
    //special case just return a nice name
    return <Box>Billing Account</Box>;
  }

  return (
    <>{resourceGroup ? <Box>{resourceGroup.name}</Box> : <Box>{wantedResource}</Box>}</>
  );
};

export default React.memo(NiceResourceGroup);
